export const SCREENS = {
    GAME_CHOICE: "gameChoice",
    PLAYER_SCREEN: "playerScreen",
    GAME_OVERVIEW: "gameOverview",
    PLAYLISTS: "playlists",
    SONG_PLAYER: "songPlayer",
    SONG_REVEAL: "songReveal",
    SCORE_KEEPER: "scoreKeeper",
    QUIZ_MASTER: "quizMaster",
    MANAGE_PLAYLIST: "managePlaylist"
};

